import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, Grid, Typography, Avatar } from '@material-ui/core';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import MoneyIcon from '@material-ui/icons/Money';
import GpsFixedIcon from '@material-ui/icons/GpsFixed';
import UnarchiveIcon from '@material-ui/icons/Unarchive';
import { ThemeStyle } from '@material-ui/core/styles/createTypography';
import TrendingDownIcon from '@material-ui/icons/TrendingDown';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%'
  },
  content: {
    alignItems: 'center',
    display: 'flex'
  },
  title: {
    fontWeight: 700
  },
  avatar: {
    height: 56,
    width: 56
  },
  icon: {
    height: 32,
    width: 32
  },
  difference: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  differenceIcon: {
    color: theme.palette.error.dark
  },
  differenceValue: {
    color: theme.palette.error.dark,
    marginRight: theme.spacing(1)
  }
}));
function CardTotalizacao(props) {

  const {
    className,
    icon,
    backgroundColorIcon,
    colorIcon,
    title,
    value,
    backgroundColorCard,
    colorCard,
    colorText,
    ...rest } = props;

  const classes = useStyles();

  function getIcon() {
    if (icon === 'GpsFixedIcon') {
      return <GpsFixedIcon
        className={classes.icon}
      />
    }
    if (icon === 'UnarchiveIcon') {
      return <UnarchiveIcon className={classes.icon}/>
    }
    if (icon === 'TrendingDownIcon') {
      return <TrendingDownIcon className={classes.icon}/>
    }
    if (icon === 'AttachMoneyIcon') {
      return <AttachMoneyIcon className={classes.icon}/>
    }
    if (icon === 'FormatListBulletedIcon') {
      return <FormatListBulletedIcon className={classes.icon}/>
    }
    if(icon === 'AccessTimeIcon'){
      return <AccessTimeIcon className={classes.icon}/>
    }
    if (icon === 'AddShoppingCartIcon') {
      return <AddShoppingCartIcon className={classes.icon}/>
    }
    if (icon === 'PlaylistAddCheckIcon') {
      return <PlaylistAddCheckIcon className={classes.icon}/>
    }
  }

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
      style={{
        backgroundColor: backgroundColorCard,
        color: colorCard
      }}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
        >
          <Grid item>
            <Typography
              className={classes.title}
              color={colorText}
              gutterBottom
              variant="body2"
            >
              {title}
            </Typography>
            <Typography
              variant="h3"
              color={colorText}
            >
              {value}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar
              className={classes.avatar}
              style={{
                backgroundColor: backgroundColorIcon,
                color: colorIcon
              }}
            >
              {getIcon()}
            </Avatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

CardTotalizacao.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  color: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.string,
};

export default CardTotalizacao;
